/* OneImpulse theme · one small script, no libraries. Each part runs only if its markup is on the page. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('js');
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- announcement: rotate messages ---------- */
  $$('[data-ann]').forEach(function (bar) {
    var msgs = $$('.ann__msg', bar), i = 0;
    if (msgs.length < 2 || REDUCE) return;
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, +(bar.dataset.ann || 5000));
  });

  /* ---------- header: always visible; the glass deepens a touch once the page scrolls ---------- */
  var hdr = $('[data-header]');
  if (hdr) {
    var hTick = false;
    var hPaint = function () { hTick = false; hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', function () { if (!hTick) { hTick = true; requestAnimationFrame(hPaint); } }, { passive: true });
    hPaint();
  }

  /* ---------- full-screen menu ---------- */
  var menu = $('[data-menu]'), menuBtn = $('[data-menu-toggle]');
  function setMenu(open) {
    if (!menu) return;
    d.body.classList.toggle('menu-open', open); d.body.classList.toggle('lock', open);
    menuBtn && menuBtn.setAttribute('aria-expanded', open);
    menu.setAttribute('aria-hidden', !open);
    if (open) { var f = $('a', menu); f && f.focus({ preventScroll: true }); }
  }
  if (menu && menuBtn) {
    menuBtn.addEventListener('click', function () { setMenu(!d.body.classList.contains('menu-open')); });
    $$('[data-menu-img]', menu).forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var k = a.getAttribute('data-menu-img');
        $$('.menu__img img', menu).forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-k') === k); });
      });
    });
  }

  /* ---------- drawers (bag, size guide) ---------- */
  var scrim = $('[data-scrim]'), openDrawer = null;
  function drawer(el, open) {
    if (!el) return;
    if (open && openDrawer && openDrawer !== el) drawer(openDrawer, false);
    el.classList.toggle('is-open', open); el.setAttribute('aria-hidden', !open);
    scrim && scrim.classList.toggle('is-on', open);
    d.body.classList.toggle('lock', open);
    openDrawer = open ? el : null;
    if (open) { var c = $('[data-close]', el); c && c.focus({ preventScroll: true }); }
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-drawer]');
    if (t) { e.preventDefault(); drawer(d.getElementById(t.getAttribute('data-open-drawer')), true); return; }
    if (e.target.closest('[data-close]') || e.target === scrim) { drawer(openDrawer, false); }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { drawer(openDrawer, false); setMenu(false); }
  });

  /* ---------- cart: add without leaving the page ---------- */
  function refreshCart(open) {
    return fetch((window.OI && OI.routes.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
        var fresh = html.querySelector('#bag'), cur = d.getElementById('bag');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        var n = html.querySelector('[data-count]'); var c = n ? n.getAttribute('data-count') : null;
        $$('[data-cart-count]').forEach(function (el) { if (c !== null) { el.textContent = c; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); } });
        if (open) drawer(d.getElementById('bag'), true);
      });
  }
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('form.js-add');
    if (!f) return;
    e.preventDefault();
    var btn = $('[type="submit"]', f), label = btn && btn.innerHTML, msg = $('[data-add-msg]', f);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(OI.routes.cart_add + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { d.dispatchEvent(new CustomEvent('oi:added')); return refreshCart(true); })
      .catch(function (err) { if (msg) msg.textContent = (err && err.description) || 'That size could not be added. Try another.'; })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (!q) return;
    e.preventDefault();
    q.disabled = true;
    fetch(OI.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: +q.getAttribute('data-line'), quantity: +q.getAttribute('data-line-qty') }) })
      .then(function () { return refreshCart(false); });
  });


  /* ---------- quick add on product cards: pick options, add to the bag, stay on the page ---------- */
  function qaClose(c) { if (!c) return; c.classList.remove('is-qa'); var b = $('[data-qa-open]', c); if (b) b.setAttribute('aria-expanded', 'false'); }
  d.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qa-open]');
    if (open) { var c = open.closest('[data-card]'); $$('[data-card].is-qa').forEach(function (x) { if (x !== c) qaClose(x); }); c.classList.add('is-qa'); open.setAttribute('aria-expanded', 'true'); qaPaint(c); var f = $('.card__qa-opt:not([disabled])', c) || $('[data-qa-close]', c); f && f.focus({ preventScroll: true }); return; }
    if (e.target.closest('[data-qa-close]')) { qaClose(e.target.closest('[data-card]')); return; }
    var opt = e.target.closest('[data-qa-opt]');
    if (opt && !opt.disabled) {
      var card = opt.closest('[data-card]'), row = opt.closest('[data-qa-row]');
      $$('[data-qa-opt]', row).forEach(function (b) { b.classList.toggle('is-on', b === opt); });
      var pick = qaPaint(card);
      if (pick) { var f2 = $('form.js-add', card); $('input[name="id"]', f2).value = pick.id; opt.classList.add('is-adding'); var m = $('[data-add-msg]', f2); if (m) m.textContent = '';
        var done = function () { opt.classList.remove('is-adding'); setTimeout(function () { qaClose(card); $$('[data-qa-opt].is-on', card).forEach(function (b) { b.classList.remove('is-on'); }); }, 250); };
        d.addEventListener('oi:added', done, { once: true });
        if (f2.requestSubmit) f2.requestSubmit(); else f2.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        setTimeout(function () { opt.classList.remove('is-adding'); }, 4000);
      }
      return;
    }
    $$('[data-card].is-qa').forEach(function (x) { if (!x.contains(e.target)) qaClose(x); });
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('[data-card].is-qa').forEach(qaClose); });
  // grey out choices that don't exist or are sold out given what's already picked; returns the variant once every option is picked
  function qaPaint(card) {
    var vs = JSON.parse(($('[data-qa-variants]', card) || {}).textContent || '[]'), rows = $$('[data-qa-row]', card);
    var sel = rows.map(function (r) { var on = $('.is-on', r); return on ? on.getAttribute('data-qa-opt') : null; });
    rows.forEach(function (r, ri) {
      $$('[data-qa-opt]', r).forEach(function (b) {
        var t = sel.slice(); t[ri] = b.getAttribute('data-qa-opt');
        var ok = vs.some(function (v) { return v.a && v.o.every(function (o, i) { return t[i] == null || o === t[i]; }); });
        b.disabled = !ok; if (!ok) b.classList.remove('is-on');
      });
    });
    if (sel.some(function (x) { return x == null; })) return null;
    return vs.filter(function (v) { return v.a && v.o.every(function (o, i) { return o === sel[i]; }); })[0] || null;
  }

  /* ---------- reels ----------
     Muted: every reel on screen plays silently.
     Tap for sound: sound follows whichever reel you're looking at as you slide, the others stay muted,
     and the site music pauses. Tap again to mute everything (the music comes back if it was playing). */
  var reelSound = false, musicWasOn = false;
  function reelVideos() { return $$('[data-reel] video'); }
  function mostVisibleReel() {
    var best = null, bestScore = 0, vw = window.innerWidth, vh = window.innerHeight;
    $$('[data-reel]').forEach(function (r) {
      var b = r.getBoundingClientRect();
      var w = Math.max(0, Math.min(b.right, vw) - Math.max(b.left, 0)), h = Math.max(0, Math.min(b.bottom, vh) - Math.max(b.top, 0));
      var score = (w * h) / Math.max(1, b.width * b.height); // share of the reel on screen
      if (score > .55) { var cx = Math.abs((b.left + b.right) / 2 - vw / 2); score += 1 - cx / vw; }
      if (score > bestScore) { bestScore = score; best = r; }
    });
    return bestScore > .55 ? best : null;
  }
  function setSoundReel(r) {
    $$('[data-reel]').forEach(function (o) {
      var v = $('video', o); var on = o === r;
      o.classList.toggle('is-sound', on && reelSound);
      var b = $('[data-reel-label]', o); if (b) b.setAttribute('aria-label', on && reelSound ? 'Mute' : 'Play with sound');
      if (!v) return;
      if (on && reelSound) {
        v.muted = false;
        var pr = v.play();
        // if the browser refuses sound here, keep playing muted and invite a tap
        pr && pr.catch(function () { v.muted = true; o.classList.remove('is-sound'); o.classList.add('is-ask'); setTimeout(function () { o.classList.remove('is-ask'); }, 3400); v.play().catch(function () {}); });
      } else { v.muted = true; }
    });
  }
  function soundOn(r) {
    reelSound = true;
    if (window.OIPlayer && !musicWasOn) { musicWasOn = OIPlayer.isPlaying(); if (musicWasOn) OIPlayer.pause(true); }
    // inside the tap, let every reel play with sound once, so sliding to another reel can keep the sound (needed on iPhone)
    reelVideos().forEach(function (v) {
      if (v.closest('[data-reel]') === r) return;
      v.muted = false; var pr = v.play(); v.muted = true;
      pr && pr.then(function () { if (!inView(v)) v.pause(); }).catch(function () {});
    });
    setSoundReel(r);
  }
  function soundOff() {
    reelSound = false; setSoundReel(null);
    if (musicWasOn && window.OIPlayer) OIPlayer.play(); musicWasOn = false;
  }
  function inView(v) { var b = v.getBoundingClientRect(); return b.right > 0 && b.left < window.innerWidth && b.bottom > 0 && b.top < window.innerHeight; }
  d.addEventListener('click', function (e) {
    var r = e.target.closest('[data-reel]'); if (!r || e.target.closest('a')) return;
    if (!$('video', r)) return;
    if (reelSound && r.classList.contains('is-sound')) soundOff(); else soundOn(r);
  });
  d.addEventListener('keydown', function (e) { var r = e.target.closest && e.target.closest('[data-reel]'); if (r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); r.click(); } });
  // while sliding (sideways on phones, or scrolling the page), hand the sound to the reel in view
  var rTick = null;
  function followSound() {
    if (!reelSound || rTick) return;
    rTick = requestAnimationFrame(function () {
      rTick = null; var r = mostVisibleReel(), cur = $('[data-reel].is-sound');
      if (r !== cur) setSoundReel(r);
    });
  }
  window.addEventListener('scroll', followSound, { passive: true });
  d.addEventListener('scroll', function (e) { if (e.target && e.target.classList && e.target.classList.contains('reels')) followSound(); }, { passive: true, capture: true });
  // the music player's own play button ends reel sound
  d.addEventListener('oi:music-play', function () { if (reelSound) { musicWasOn = false; reelSound = false; setSoundReel(null); } });

  /* ---------- product gallery: scan, zoom on hover, full screen ---------- */
  function handleize(x) { return String(x || '').toLowerCase().trim().replace(/['"’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var FINE = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function gallery(g) {
    if (g._gal) return g._gal;
    var track = $('[data-gal-track]', g), stage = $('.gal__stage', g); if (!track) return null;
    var slides = $$('.gal__slide', g), thumbs = $$('.gal__thumb', g), count = $('[data-gal-count]', g), barsEl = $('[data-gal-bars]', g),
      prevB = $('[data-gal-prev]', g), nextB = $('[data-gal-next]', g), cur = 0, lbx = null, lbxDirty = true, bars = [];
    if (barsEl && slides.length > 1) { barsEl.innerHTML = slides.map(function () { return '<i></i>'; }).join(''); bars = $$('i', barsEl); }
    var ZOOM = parseFloat(getComputedStyle(g.closest('[data-product]') || g).getPropertyValue('--zoom')) || 2.5;
    function vis() { return slides.filter(function (s) { return !s.classList.contains('is-off'); }); }
    function setCur(i) {
      cur = i; var v = vis(), pos = Math.max(0, v.indexOf(slides[i]));
      if (count) count.textContent = v.length > 1 ? pad(pos + 1) + ' / ' + pad(v.length) : '';
      thumbs.forEach(function (t, k) { t.classList.toggle('is-cur', k === i); t.setAttribute('aria-current', k === i); });
      bars.forEach(function (b, k) { b.classList.toggle('is-cur', k === i); });
      if (prevB) prevB.disabled = pos <= 0; if (nextB) nextB.disabled = pos >= v.length - 1;
      var th = thumbs[i], box = th && th.parentElement;
      if (th && box && box.scrollHeight > box.clientHeight + 2) { var top = th.offsetTop - box.offsetTop; if (top < box.scrollTop || top + th.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: top - 8, behavior: 'smooth' }); }
      var nx = v[pos + 1]; if (nx) { var im = $('img', nx); if (im && im.loading === 'lazy') im.loading = 'eager'; }
      slides.forEach(function (s, k) { var vd = $('video', s); if (vd && k !== i) vd.pause(); });
    }
    function go(i, instant) {
      var s = slides[i]; if (!s || s.classList.contains('is-off')) return;
      var pos = vis().indexOf(s);
      track.scrollTo({ left: pos * track.clientWidth, behavior: instant || REDUCE ? 'auto' : 'smooth' });
      setCur(i);
    }
    function step(n) { var v = vis(), pos = v.indexOf(slides[cur]) + n; if (v[pos]) go(slides.indexOf(v[pos])); }
    var st = null, settling = false;
    track.addEventListener('scroll', function () {
      if (zoomOn) stopZoom();
      if (st) return;
      st = requestAnimationFrame(function () { st = null; var v = vis(), k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (v[k] && slides.indexOf(v[k]) !== cur) setCur(slides.indexOf(v[k])); });
    }, { passive: true });
    prevB && prevB.addEventListener('click', function () { step(-1); });
    nextB && nextB.addEventListener('click', function () { step(1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); step(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); } if (e.key === 'Enter') openLbx(cur); });
    window.addEventListener('resize', function () { if (g.isConnected) go(cur, true); });

    /* magnifier: a circle that shows the detail under it, close up; the rest of the photo stays as it is.
       Mouse and trackpad: it follows the pointer on hover. Phones: touch and hold the photo, then slide your
       finger; the circle sits just above your finger so it's never hidden. Let go and it's gone. */
    var zoomOn = false, zTimer = null, lens = null, zSlide = null, raf = null, rx = 0, ry = 0, geo = null, byTouch = false, noClick = false;
    lens = d.createElement('div'); lens.className = 'gal__loupe'; lens.setAttribute('aria-hidden', 'true');
    stage.appendChild(lens);
    function measure(slide) {
      // where the photo actually sits in the frame (it fills the frame, cropped from its focal point)
      var im = $('img', slide), W = stage.clientWidth, H = stage.clientHeight, w = im && im.naturalWidth || 4, h = im && im.naturalHeight || 5;
      var sc = Math.max(W / w, H / h), dw = w * sc, dh = h * sc;
      var pos = (im && getComputedStyle(im).objectPosition || '50% 50%').split(' ');
      var fx = parseFloat(pos[0]) / 100, fy = parseFloat(pos[1] || pos[0]) / 100; if (isNaN(fx)) fx = .5; if (isNaN(fy)) fy = .5;
      geo = { dw: dw, dh: dh, ox: (W - dw) * fx, oy: (H - dh) * fy, R: lens.offsetWidth / 2 || 100 };
      lens.style.backgroundSize = Math.round(dw * ZOOM) + 'px ' + Math.round(dh * ZOOM) + 'px';
    }
    function startZoom(slide) {
      var im = slide && $('img', slide); if (!im || slide.dataset.type !== 'image') return;
      zSlide = slide; zoomOn = true;
      lens.style.backgroundImage = 'url("' + (slide._hi || im.currentSrc || im.src) + '")';
      g.classList.add('is-zoom'); measure(slide);
      if (!slide._hi && slide.dataset.zoom) {
        var hi = new Image(); hi.decoding = 'async';
        hi.onload = function () { slide._hi = hi.src; if (zSlide === slide) lens.style.backgroundImage = 'url("' + hi.src + '")'; };
        hi.src = slide.dataset.zoom;
      }
      paintZoom();
    }
    function stopZoom() { clearTimeout(zTimer); zTimer = null; zoomOn = false; zSlide = null; g.classList.remove('is-zoom', 'is-touchzoom'); }
    function paintZoom() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null; if (!lens || !geo) return;
        var ix = rx - geo.ox, iy = ry - geo.oy, lift = 0;
        // on a phone, lift the circle above the finger (or below it, near the top of the photo)
        if (byTouch) lift = ry - geo.R * 2 - 28 >= 0 ? geo.R + 28 : -(geo.R + 28);
        lens.style.transform = 'translate3d(' + (rx - geo.R) + 'px,' + (ry - geo.R - lift) + 'px,0)';
        lens.style.backgroundPosition = (geo.R - ix * ZOOM).toFixed(1) + 'px ' + (geo.R - iy * ZOOM).toFixed(1) + 'px';
      });
    }
    if (FINE) {
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (e.target.closest && e.target.closest('.gal__nav')) { stopZoom(); return; }
        var r = stage.getBoundingClientRect(); rx = e.clientX - r.left; ry = e.clientY - r.top;
        var s = slides[cur];
        if (!s || s.dataset.type !== 'image') { stopZoom(); return; }
        if (!zoomOn) { if (!zTimer) zTimer = setTimeout(function () { zTimer = null; startZoom(slides[cur]); }, 60); }
        else if (zSlide !== s) startZoom(s);
        paintZoom();
      });
      stage.addEventListener('pointerleave', function () { if (!byTouch) stopZoom(); });
    }
    window.addEventListener('resize', function () { if (zoomOn && zSlide) measure(zSlide); });
    // phones: touch and hold to zoom; a quick swipe still changes photo and a quick tap still opens full screen
    var t0 = null;
    function touchPoint(t) { var r = stage.getBoundingClientRect(); rx = t.clientX - r.left; ry = t.clientY - r.top; }
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { clearTimeout(zTimer); if (zoomOn) stopZoom(); return; }
      var s = slides[cur]; if (!s || s.dataset.type !== 'image' || (e.target.closest && e.target.closest('.gal__nav'))) return;
      var t = e.touches[0]; t0 = { x: t.clientX, y: t.clientY }; touchPoint(t);
      clearTimeout(zTimer);
      zTimer = setTimeout(function () {
        zTimer = null; byTouch = true; noClick = true; startZoom(slides[cur]); g.classList.add('is-touchzoom', 'is-used');
        if (navigator.vibrate) try { navigator.vibrate(8); } catch (x) {}
      }, 260);
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      var t = e.touches[0]; if (!t) return;
      if (zoomOn && byTouch) { e.preventDefault(); touchPoint(t); paintZoom(); return; } // while zooming, the page and photos stay still
      if (zTimer && t0 && (Math.abs(t.clientX - t0.x) > 8 || Math.abs(t.clientY - t0.y) > 8)) { clearTimeout(zTimer); zTimer = null; } // it's a swipe or a scroll
    }, { passive: false });
    function touchDone() { clearTimeout(zTimer); zTimer = null; t0 = null; if (zoomOn && byTouch) stopZoom(); byTouch = false; if (noClick) setTimeout(function () { noClick = false; }, 450); }
    stage.addEventListener('touchend', touchDone); stage.addEventListener('touchcancel', touchDone);
    stage.addEventListener('contextmenu', function (e) { if (noClick || zoomOn) e.preventDefault(); });

    /* full screen */
    var ltrack = null, lpos = 0, lcur = 0;
    function buildLbx() {
      if (!lbx) {
        lbx = d.createElement('dialog'); lbx.className = 'lbx'; lbx.setAttribute('aria-label', 'Photos');
        lbx.addEventListener('close', function () { d.body.classList.remove('lock'); go(lcur, true); });
        lbx.addEventListener('click', function (e) {
          if (e.target.closest('[data-lbx-close]')) lbx.close();
          else if (e.target.closest('[data-lbx-prev]')) lstep(-1);
          else if (e.target.closest('[data-lbx-next]')) lstep(1);
          else if (e.target.closest('[data-lbx-go]')) lgo(+e.target.closest('[data-lbx-go]').getAttribute('data-lbx-go'));
          else if (e.target.tagName === 'IMG' && e.target.closest('.lbx__slide')) { var sl = e.target.closest('.lbx__slide'); setOrigin(sl, e); sl.classList.toggle('is-z'); ltrack.style.overflowX = sl.classList.contains('is-z') ? 'hidden' : ''; }
          else if (e.target.classList.contains('lbx__slide')) lbx.close();
        });
        lbx.addEventListener('pointermove', function (e) { var sl = e.target.closest && e.target.closest('.lbx__slide.is-z'); if (sl) setOrigin(sl, e); });
        lbx.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') lstep(1); if (e.key === 'ArrowLeft') lstep(-1); });
        d.body.appendChild(lbx);
      }
      var v = vis();
      lbx.innerHTML = '<div class="lbx__track" data-lbx-track>' + v.map(function (s) {
        var im = $('img', s), vd = $('video', s);
        if (vd) return '<div class="lbx__slide"><video src="' + (vd.currentSrc || vd.src || ($('source', vd) || {}).src || '') + '" controls playsinline muted></video></div>';
        return '<div class="lbx__slide"><img src="' + (s._hi || s.dataset.zoom || (im && (im.currentSrc || im.src)) || '') + '" alt="' + ((im && im.alt) || '').replace(/"/g, '&quot;') + '" loading="lazy" decoding="async" draggable="false"></div>';
      }).join('') + '</div>' +
        '<div class="lbx__bar"><span class="num" data-lbx-count></span><button class="ib" type="button" data-lbx-close aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg></button></div>' +
        (v.length > 1 ? '<button class="ib lbx__prev" type="button" data-lbx-prev aria-label="Previous photo"><svg width="18" height="18" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></button><button class="ib lbx__next" type="button" data-lbx-next aria-label="Next photo"><svg width="18" height="18" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></button>' +
        '<div class="lbx__thumbs">' + v.map(function (s, k) { var im = $('img', s) || $('video', s); var src = im ? (im.currentSrc || im.src || im.poster || '') : ''; return '<button type="button" data-lbx-go="' + k + '" aria-label="Photo ' + (k + 1) + '">' + (src ? '<img src="' + src + '" alt="">' : '') + '</button>'; }).join('') + '</div>' : '');
      ltrack = $('[data-lbx-track]', lbx);
      var lst = null;
      ltrack.addEventListener('scroll', function () { if (lst) return; lst = requestAnimationFrame(function () { lst = null; var k = Math.round(ltrack.scrollLeft / Math.max(1, ltrack.clientWidth)); if (k !== lpos) lset(k); }); }, { passive: true });
      lbxDirty = false;
    }
    function setOrigin(sl, e) { var im = $('img', sl); if (!im) return; var r = im.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'; }
    function lset(k) {
      var v = vis(); lpos = k; lcur = slides.indexOf(v[k]);
      var c = $('[data-lbx-count]', lbx); if (c) c.textContent = pad(k + 1) + ' / ' + pad(v.length);
      $$('[data-lbx-go]', lbx).forEach(function (b, j) { b.classList.toggle('is-cur', j === k); });
      $$('.lbx__slide.is-z', lbx).forEach(function (s) { s.classList.remove('is-z'); }); ltrack.style.overflowX = '';
    }
    function lgo(k, instant) { var v = vis(); if (!v[k]) return; ltrack.scrollTo({ left: k * ltrack.clientWidth, behavior: instant || REDUCE ? 'auto' : 'smooth' }); lset(k); }
    function lstep(n) { lgo(lpos + n); }
    function openLbx(i) {
      if (!window.HTMLDialogElement) return;
      stopZoom(); if (lbxDirty || !lbx) buildLbx();
      lbx.showModal(); d.body.classList.add('lock');
      lgo(Math.max(0, vis().indexOf(slides[i])), true);
      var cb = $('[data-lbx-close]', lbx); cb && cb.focus({ preventScroll: true });
    }
    track.addEventListener('click', function (e) {
      if (noClick) { noClick = false; return; } // that was a hold-to-zoom, not a tap
      var s = e.target.closest('.gal__slide'); if (!s || $('video', s) || $('iframe', s)) return;
      openLbx(slides.indexOf(s));
    });

    /* colour: show only that colour's photos (plus photos not tied to a colour) */
    var hasColors = slides.some(function (s) { return s.dataset.color; });
    function showVariant(colorValue, mediaId, instant) {
      if (hasColors && colorValue != null) {
        var h = handleize(colorValue), any = slides.some(function (s) { return s.dataset.color === h; });
        slides.forEach(function (s, k) {
          var off = any && !!s.dataset.color && s.dataset.color !== h;
          s.classList.toggle('is-off', off); if (thumbs[k]) thumbs[k].classList.toggle('is-off', off); if (bars[k]) bars[k].classList.toggle('is-off', off);
        });
        lbxDirty = true;
      }
      var target = mediaId ? slides.filter(function (s) { return s.dataset.media == String(mediaId) && !s.classList.contains('is-off'); })[0] : null;
      if (!target) target = vis()[0];
      if (target) { if (hasColors) g.classList.add('is-swap'); go(slides.indexOf(target), true); setTimeout(function () { g.classList.remove('is-swap'); }, 40); }
    }
    setCur(0);
    g._gal = { go: go, showVariant: showVariant };
    return g._gal;
  }

  /* ---------- page parts (run on load; the preview calls this again after each page change) ---------- */
  function pageInit() {
  // a new page always starts with the reels muted
  if (reelSound && !$('[data-reel].is-sound')) { reelSound = false; musicWasOn = false; }
  /* ---------- reveal on scroll (content is visible without JS) ---------- */
  if ('IntersectionObserver' in window && !REDUCE) {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight) { el.classList.add('pre'); rio.observe(el); }
    });
  }

  /* ---------- product: variant picker ---------- */
  $$('[data-product]').forEach(function (p) {
    if (p._oi) return; p._oi = 1;
    var json = $('script[data-variants]', p); if (!json) return;
    var variants = JSON.parse(json.textContent), idInput = $('input[name="id"]', p), btn = $('[data-add]', p), priceEl = $('[data-price]', p);
    var gEl = $('[data-gallery]', p), gal = gEl ? gallery(gEl) : null;
    function showColor(mediaId, instant) {
      if (!gal) return;
      var cfs = $('fieldset[data-opt-color]', p), c = cfs && $('input:checked', cfs);
      gal.showVariant(c ? c.value : null, mediaId, instant);
    }
    function selected() { return $$('fieldset[data-opt]', p).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      // mark sizes that don't exist or are sold out for the chosen colour
      $$('fieldset[data-opt]', p).forEach(function (fs, oi) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var m = variants.filter(function (x) { return x.options.every(function (o, i) { return o === test[i]; }); })[0];
          inp.classList.toggle('is-na', !m || !m.available);
        });
        var out = $('[data-opt-value]', fs); if (out) out.textContent = sel[oi] || '';
      });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      showColor(v.image, false);
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    p.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-opt]')) update(); });
    // open on the chosen colour's photos
    (function () { var first = variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0]; showColor(first && first.image, true); })();
  });

  $$('[data-gallery]').forEach(gallery);

  var reels = $$('[data-reel] video').filter(function (v) { if (v._oi) return false; v._oi = 1; return true; });
  reels.forEach(function (v) {
    var r = v.closest('[data-reel]');
    function ready() { r.classList.add('is-ready'); }
    if (v.readyState >= 3 && !v.paused) ready();
    v.addEventListener('playing', ready);
    v.addEventListener('timeupdate', function t() { if (v.currentTime > 0) { ready(); v.removeEventListener('timeupdate', t); } });
  });
  if (reels.length && 'IntersectionObserver' in window) {
    // start loading a little before a reel comes on screen so it begins without a pause
    var warm = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var v = e.target; if (v.preload !== 'auto') { v.preload = 'auto'; } warm.unobserve(v); } }); }, { rootMargin: '400px 400px' });
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!reelSound) v.muted = true; var pr = v.play(); pr && pr.catch(function () {}); }
        else if (!e.isIntersecting) { v.pause(); }
      });
      followSound();
    }, { threshold: [0, .35, .7] });
    reels.forEach(function (v) { warm.observe(v); vio.observe(v); });
  }
  /* ---------- lookbook ---------- */
  $$('[data-lookbook]').forEach(function (lb) {
    if (lb._oi) return; lb._oi = 1;
    var slides = $$('.lb__slide', lb), idx = $$('.lb__idx button', lb), title = $('[data-lb-title]', lb), cur = 0, timer = null,
      dur = +(lb.dataset.interval || 5000), paused = REDUCE, pauseBtn = $('[data-lb-pause]', lb), filter = null;
    lb.style.setProperty('--dur', dur + 'ms');
    function visible() { return slides.map(function (s, i) { return i; }).filter(function (i) { return !filter || (slides[i].dataset.colors || '').split(',').indexOf(filter) > -1; }); }
    function show(i) {
      var list = visible(); if (!list.length) return;
      if (list.indexOf(i) < 0) i = list[0];
      cur = i;
      var pos = list.indexOf(i), prev = list[(pos - 1 + list.length) % list.length], next = list[(pos + 1) % list.length];
      slides.forEach(function (s, k) {
        s.classList.toggle('is-cur', k === i); s.classList.toggle('is-prev', k === prev && list.length > 1); s.classList.toggle('is-next', k === next && list.length > 2);
        s.setAttribute('aria-hidden', k !== i);
        if (Math.abs(list.indexOf(k) - pos) <= 1 || k === prev || k === next) { var im = $('img', s); if (im && im.loading === 'lazy') im.loading = 'eager'; }
      });
      idx.forEach(function (b, k) { b.classList.toggle('is-cur', k === i); b.classList.toggle('is-dim', list.indexOf(k) < 0); b.setAttribute('aria-current', k === i); var c = b.cloneNode(true); });
      // restart the progress line
      var active = idx[i]; if (active) { active.classList.remove('is-cur'); void active.offsetWidth; active.classList.add('is-cur'); }
      if (title) title.textContent = slides[i].dataset.title || '';
      tick();
    }
    function step(n) { var list = visible(), pos = list.indexOf(cur); show(list[(pos + n + list.length) % list.length]); }
    function tick() { clearTimeout(timer); if (!paused) timer = setTimeout(function () { step(1); }, dur); }
    function setPaused(p) { paused = p; lb.classList.toggle('is-paused', p); if (pauseBtn) pauseBtn.textContent = p ? 'play' : 'pause'; tick(); }
    lb.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-lb-prev]')) step(-1);
      else if (t.closest('[data-lb-next]')) step(1);
      else if (t.closest('[data-lb-pause]')) setPaused(!paused);
      else if (t.closest('[data-lb-first]')) show(visible()[0]);
      else if (t.closest('.lb__idx button')) show(idx.indexOf(t.closest('.lb__idx button')));
      else if (t.closest('.lb__slide.is-prev')) step(-1);
      else if (t.closest('.lb__slide.is-next')) step(1);
      else if (t.closest('[data-color]')) {
        var b = t.closest('[data-color]'), c = b.getAttribute('data-color');
        filter = filter === c ? null : c;
        $$('[data-color]', lb).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-color') === filter); });
        show(cur);
      }
    });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
    var sx = null; var stage = $('.lb__stage', lb);
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); sx = null; });
    // pause when off screen so it never runs in the background
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) clearTimeout(timer); else tick(); }); }).observe(lb);
    setPaused(paused); show(0);
  });

  }
  window.OI_THEME_INIT = pageInit;
  pageInit();

  /* ---------- currency / country picker: submit on change ---------- */
  $$('form.loc select').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- music player ----------
     Each song plays for N seconds (theme editor), fading in at the start and fading out smoothly before
     the cut, then the next song; after the last it stops. Pause and song changes fade too. */
  var pl = $('[data-player]');
  if (pl) {
    var tracks = JSON.parse($('script[data-tracks]', pl).textContent || '[]');
    if (!tracks.length) { pl.hidden = true; }
    else {
      var LIMIT = +(pl.dataset.limit || 0), FADE = Math.max(0, +(pl.dataset.fade || 4)), FADE_IN = 3,
        i = 0, playing = false, userPaused = (function () { try { return sessionStorage.getItem('oi-music') === 'off'; } catch (e) { return false; } })(), started = false, base = .7, env = 1, raf = null, fadeTo = null, ending = false;
      // iPhone and iPad don't let a page change an audio element's volume, so fades go through Web Audio there
      var probe = new Audio(); probe.volume = .5; var canVol = probe.volume === .5;
      var AC = window.AudioContext || window.webkitAudioContext, ctx = null, gain = null, useGraph = !canVol && !!AC, audio;
      var els = { t: $$('[data-t-title]', pl), a: $$('[data-t-artist]', pl), now: $('[data-t-now]', pl), len: $('[data-t-len]', pl), prog: $('[data-t-prog]', pl), hint: $('[data-hint]', pl) };
      function fmt(x) { x = Math.max(0, Math.floor(x)); return Math.floor(x / 60) + ':' + ('0' + x % 60).slice(-2); }
      function len() { var dur = isFinite(audio.duration) && audio.duration ? audio.duration : 0; if (!LIMIT) return dur || 600; return Math.min(LIMIT, dur || LIMIT); }
      function out(v) { v = Math.max(0, Math.min(1, v)); if (gain) gain.gain.value = v; else if (canVol) audio.volume = v; }
      function makeAudio(cors) {
        var a = new Audio(); a.preload = 'none'; if (cors) a.crossOrigin = 'anonymous';
        a.addEventListener('ended', function () { next(); });
        a.addEventListener('loadedmetadata', paint);
        a.addEventListener('error', function () {
          // the file host didn't allow Web Audio: fall back to plain playback (no fade on iPhone)
          if (cors && !gain) { useGraph = false; if (typeof volUI === 'function') volUI(); var t = a.currentTime, wasOn = playing; audio = makeAudio(false); audio.src = tracks[i].src; if (wasOn) { audio.currentTime = t; audio.play().catch(function () {}); } }
        });
        return a;
      }
      audio = makeAudio(useGraph);
      function graph() {
        if (!useGraph || gain) { if (ctx && ctx.state === 'suspended') ctx.resume(); return; }
        try { ctx = new AC(); var src = ctx.createMediaElementSource(audio); gain = ctx.createGain(); src.connect(gain); gain.connect(ctx.destination); gain.gain.value = 0; if (typeof volUI === 'function') volUI(); } catch (e) { useGraph = false; gain = null; if (typeof volUI === 'function') volUI(); }
      }
      function paint() {
        pl.classList.toggle('is-playing', playing);
        els.t.forEach(function (e) { e.textContent = tracks[i].title; }); els.a.forEach(function (e) { e.textContent = tracks[i].artist || ''; });
        $$('[data-toggle] path', pl).forEach(function (p) { p.setAttribute('d', playing ? 'M4 2.5h3v11H4zM9 2.5h3v11H9z' : 'M4 2.5v11l9-5.5z'); });
        $$('[data-toggle]', pl).forEach(function (b) { b.setAttribute('aria-label', playing ? 'Pause' : 'Play'); });
        if (els.len) els.len.textContent = fmt(len());
      }
      // one loop drives the fades, the progress line and the hand-off to the next song
      function loop() {
        raf = null; if (!playing) return;
        var t = audio.currentTime, L = len();
        var inE = FADE_IN ? Math.min(1, t / FADE_IN) : 1, outE = FADE ? Math.min(1, Math.max(0, (L - t) / FADE)) : 1;
        if (fadeTo) { var k = Math.min(1, (performance.now() - fadeTo.t0) / fadeTo.ms); env = fadeTo.from + (fadeTo.to - fadeTo.from) * k; if (k >= 1) { var done = fadeTo.done; fadeTo = null; done && done(); if (!playing) return; } }
        var e = Math.min(inE, outE); out(base * env * e * e); // squared curve: loudness falls away evenly, no sudden drop at the end
        if (els.now) els.now.textContent = fmt(t); if (els.prog) els.prog.style.width = (Math.min(1, t / L) * 100) + '%';
        if (t >= L - .05 && !ending) { ending = true; next(); return; }
        raf = requestAnimationFrame(loop);
      }
      function run() { if (!raf) raf = requestAnimationFrame(loop); }
      function ramp(to, ms, done) { fadeTo = { from: env, to: to, t0: performance.now(), ms: ms, done: done }; run(); }
      function load(n) { i = n; ending = false; audio.src = tracks[i].src; audio.load(); paint(); }
      function play() {
        if (!audio.src) load(i);
        graph(); env = 1; fadeTo = null; out(0);
        var p = audio.play(); started = true; if (els.hint) els.hint.hidden = true;
        if (p && p.catch) p.catch(function () { playing = false; paint(); });
        playing = true; userPaused = false; try { sessionStorage.setItem('oi-music', 'on'); } catch (e) {} paint(); run(); root.classList.add('oi-music-on');
        d.dispatchEvent(new CustomEvent('oi:music-play'));
      }
      function pause(auto) {
        if (!auto) { userPaused = true; try { sessionStorage.setItem('oi-music', 'off'); } catch (e) {} }
        if (!playing) return;
        ramp(0, 450, function () { audio.pause(); playing = false; paint(); root.classList.remove('oi-music-on'); });
        pl.classList.remove('is-playing');
      }
      function next() {
        if (i + 1 < tracks.length) { load(i + 1); play(); }
        else { audio.pause(); playing = false; out(0); audio.currentTime = 0; load(0); paint(); root.classList.remove('oi-music-on'); }
      }
      function skip(n) { // fade the current song down quickly, then change
        if (!playing) { load(n); play(); return; }
        ramp(0, 350, function () { load(n); play(); });
      }
      pl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.target.closest('[data-toggle]')) playing ? pause() : play();
        else if (e.target.closest('[data-next]')) { if (i + 1 < tracks.length) skip(i + 1); }
        else if (e.target.closest('[data-prev]')) { if (audio.currentTime > 3 || i === 0) { audio.currentTime = 0; } else skip(i - 1); }
        else if (e.target.closest('[data-expand]')) pl.classList.add('is-open');
        else if (e.target.closest('[data-collapse]')) pl.classList.remove('is-open');
      });
      // Volume: works wherever the browser lets a page set it. iPhone and iPad only allow the side buttons,
      // unless the song can be routed through Web Audio; there the slider is swapped for a short hint.
      var vol = $('[data-vol]', pl), volRow = $('.pl__vol', pl);
      if (vol) {
        var saved = parseFloat(store('oi-vol')); if (!isNaN(saved)) vol.value = Math.round(saved * 100);
        base = vol.value / 100;
        var setVol = function () {
          base = vol.value / 100; store('oi-vol', String(base)); vol.style.setProperty('--v', vol.value + '%');
          if (ctx && ctx.state === 'suspended') ctx.resume();
          if (playing) { if (!fadeTo) out(base * env); run(); }
        };
        vol.addEventListener('input', setVol); vol.addEventListener('change', setVol);
        // Drag or tap anywhere on the line (phones otherwise only move it by the small dot)
        var dragVol = function (e) { var r = vol.getBoundingClientRect(); if (!r.width) return; vol.value = Math.round(Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * 100); setVol(); };
        vol.addEventListener('pointerdown', function (e) { e.preventDefault(); e.stopPropagation(); try { vol.setPointerCapture(e.pointerId); } catch (x) {} vol.focus(); dragVol(e); });
        vol.addEventListener('pointermove', function (e) { if (vol.hasPointerCapture && vol.hasPointerCapture(e.pointerId)) dragVol(e); });
        vol.style.setProperty('--v', vol.value + '%');
      }
      function volUI() { if (!volRow) return; var ok = canVol || useGraph || !!gain; volRow.classList.toggle('is-hw', !ok); }
      volUI();
      // Plays by itself only on the home page, once per visit, and only after the visitor's first tap or key press
      // (browsers block sound before that). On every other page the player waits for them to press play.
      function sess(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
      var autoOK = pl.dataset.autostart === 'true' && pl.dataset.home === 'true' && !userPaused && !sess('oi-music-auto');
      var GESTURES = ['touchend', 'click', 'keydown']; // a finger's pointerdown doesn't unlock sound on phones
      function stopListening() { GESTURES.forEach(function (g) { d.removeEventListener(g, first, true); }); }
      function first(e) {
        if (e && e.target && e.target.closest && (e.target.closest('[data-player]') || e.target.closest('[data-reel]'))) return;
        stopListening();
        if (!started) { sess('oi-music-auto', '1'); play(); }
      }
      if (autoOK) {
        // Try to start the moment the page opens. Most browsers only allow sound after a first tap or key press,
        // so if they say no, it starts on that first touch instead.
        GESTURES.forEach(function (g) { d.addEventListener(g, first, true); });
        if (canVol) setTimeout(function () { // after the first song is loaded below
          if (started) return;
          audio.volume = 0;
          var pr = audio.play();
          if (pr && pr.then) pr.then(function () { if (!started) { stopListening(); sess('oi-music-auto', '1'); if (els.hint) els.hint.hidden = true; play(); } }).catch(function () {});
        }, 0);
      } else if (els.hint) els.hint.hidden = true;
      // Leaving the page while music plays: fade out, then go (instead of cutting off)
      d.addEventListener('click', function (e) {
        if (!playing || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest && e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-open-drawer')) return;
        var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return;
        if (window.OI_PREVIEW) return; // the preview changes pages without reloading and fades on its own
        e.preventDefault();
        var go = function () { location.href = url.href; };
        ramp(0, 900, function () { audio.pause(); go(); }); setTimeout(go, 1200);
      });
      window.OI_MUSIC_ROUTE = function (isHome) { // used by the preview, which changes pages without reloading
        pl.classList.toggle('pl--compact', !isHome);
        stopListening();
        if (els.hint) els.hint.hidden = true;
        if (playing) pause(true);
      };
      load(0);
      window.OIPlayer = { pause: pause, play: play, isPlaying: function () { return playing; } };
    }
  }
})();
